module.exports = __webpack_public_path__ + "static/media/icon-heart-full.8c631e67.svg";